export const FLASH_ALERT = 'FLASH_ALERT';
export const FLASH_SEEN = 'FLASH_SEEN';
